import Vue from 'vue';
import { keyBy, filter, head } from 'lodash';
import types from './mutation-types';

const mutations = {
  [types.SET_SERIES](state, seriesList) {
    Vue.set(state, 'series', {
      ...state.series,
      ...keyBy(seriesList, eachSeries => eachSeries.id),
    });
  },

  [types.REMOVE_SERIES](state, seriesId) {
    const filteredList = filter(state.series, eachSeries => (
      eachSeries.id !== seriesId
    ));

    Vue.set(state, 'series', keyBy(filteredList, eachSeries => eachSeries.id));
  },

  [types.SET_NON_SERIES_CARDS](state, nonSeriesCardList) {
    Vue.set(state, 'nonSeriesCards', {
      ...state.nonSeriesCards,
      ...keyBy(nonSeriesCardList, card => card.id),
    });
  },

  [types.REMOVE_NON_SERIES_CARD](state, cardId) {
    const filteredList = filter(state.nonSeriesCards, card => (
      card.id !== cardId
    ));

    Vue.set(state, 'nonSeriesCards', keyBy(filteredList, card => card.id));
  },

  [types.SET_CHAPTERS](state, chapterList) {
    Vue.set(state, 'chapters', {
      ...state.chapters,
      ...keyBy(chapterList, chapter => chapter.id),
    });
  },

  [types.SET_CHAPTER_CARDS](state, cards) {
    Vue.set(state, 'chapterCards', {
      ...state.chapterCards,
      ...keyBy(cards, card => card.id),
    });
  },

  [types.REMOVE_CHAPTER_CARD](state, cardId) {
    const filteredList = filter(state.chapterCards, card => (
      card.id !== cardId
    ));

    Vue.set(state, 'chapterCards', keyBy(filteredList, card => card.id));
  },

  [types.REQUEST_VIDEO_COURSE_CARD](state) {
    Vue.set(state, 'isLoadingVideoCourseCard', true);
  },

  [types.SET_VIDEO_COURSE_CARD](state, videoCourseCard) {
    Vue.set(state, 'videoCourseCard', videoCourseCard);
    Vue.set(state, 'isLoadingVideoCourseCard', false);
  },

  [types.FETCH_VIDEO_COURSE_CARDS](state, videoCourseCards) {
    Vue.set(state, 'videoCourseCard', head(videoCourseCards));
    Vue.set(state, 'isLoadingVideoCourseCard', false);
  },

  [types.UPDATE_VIDEO_COURSE_CARD](state, videoCourseCard) {
    Vue.set(state, 'videoCourseCard', videoCourseCard);
    Vue.set(state, 'isLoadingVideoCourseCard', false);
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/publishers/store/mutations.js